export function blurFocus(e: MouseEvent) {
  const el = e.currentTarget;
  if (document.activeElement === el) {
    e.preventDefault();
    el.blur();
  }
}
